<template>
  <vx-card title="Bestellungen & Ø Bestellwert">
    <div class="flex mb-4">
      <vs-button
        v-for="p in periods"
        :key="p.value"
        :type="activePeriod === p.value ? 'filled' : 'border'"
        size="small"
        class="mr-2"
        @click="changePeriod(p.value)"
      >
        {{ p.label }}
      </vs-button>
    </div>
    <vue-apex-charts
      type="line"
      height="350"
      :options="chartOptions"
      :series="series"
    />
  </vx-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "AnalyticsOrdersAndAvg",
  components: { VueApexCharts },
  data() {
    return {
      activePeriod: "daily",
      periods: [
        { label: "Täglich", value: "daily" },
        { label: "Wöchentlich", value: "weekly" },
        { label: "Monatlich", value: "monthly" },
      ],
    };
  },
  computed: {
    avgData() {
      return this.$store.state.analytics.avgOrderValue || [];
    },
    globalAvg() {
      const kpi = this.$store.state.analytics.kpiSummary;
      return kpi ? Math.round(kpi.avgOrderValue * 100) / 100 : null;
    },
    series() {
      return [
        {
          name: "Bestellungen",
          type: "column",
          data: this.avgData.map((item) => item.orders),
        },
        {
          name: "Ø Bestellwert",
          type: "line",
          data: this.avgData.map(
            (item) => Math.round(item.avgOrderValue * 100) / 100
          ),
        },
      ];
    },
    labels() {
      return this.avgData.map((item) =>
        this.formatDate(item._id, this.activePeriod)
      );
    },
    chartOptions() {
      return {
        chart: {
          toolbar: { show: false },
          foreColor: "#c2c6dc",
          background: "transparent",
        },
        theme: { mode: "dark" },
        grid: { borderColor: "rgba(255,255,255,0.06)" },
        xaxis: { categories: this.labels },
        yaxis: [
          {
            title: { text: "Bestellungen", style: { color: "#C41E2A" } },
            labels: { formatter: (val) => Math.round(val).toString() },
          },
          {
            opposite: true,
            title: { text: "Ø Wert", style: { color: "#2ECC71" } },
            labels: { formatter: (val) => val.toFixed(0) + " €" },
          },
        ],
        dataLabels: { enabled: false },
        stroke: { width: [0, 4], curve: "smooth" },
        colors: ["#C41E2A", "#2ECC71"],
        fill: { opacity: [0.7, 1] },
        plotOptions: {
          bar: { borderRadius: 3, columnWidth: "55%" },
        },
        markers: {
          size: [0, 3],
          strokeWidth: 0,
          hover: { size: 6 },
        },
        legend: { position: "top", labels: { colors: "#c2c6dc" } },
        annotations: {
          yaxis: this.globalAvg
            ? [
                {
                  y: this.globalAvg,
                  yAxisIndex: 1,
                  borderColor: "rgba(46,204,113,0.5)",
                  borderWidth: 2,
                  strokeDashArray: 6,
                  label: {
                    text: "Ø gesamt: " + this.globalAvg.toFixed(2) + " €",
                    position: "left",
                    offsetX: 10,
                    style: {
                      color: "#fff",
                      background: "rgba(46,204,113,0.25)",
                      fontSize: "11px",
                      padding: { left: 6, right: 6, top: 2, bottom: 2 },
                    },
                  },
                },
              ]
            : [],
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
      };
    },
  },
  methods: {
    formatDate(dateStr, period) {
      const parts = dateStr.split("-");
      if (period === "monthly") {
        const months = [
          "Jan",
          "Feb",
          "Mär",
          "Apr",
          "Mai",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Okt",
          "Nov",
          "Dez",
        ];
        return `${months[parseInt(parts[1]) - 1]} ${parts[0]}`;
      }
      return `${parts[2]}.${parts[1]}`;
    },
    changePeriod(period) {
      this.activePeriod = period;
      const daysMap = { daily: 30, weekly: 90, monthly: 730 };
      this.$store.dispatch("analytics/fetchAvgOrderValue", {
        period,
        days: daysMap[period],
      });
    },
  },
};
</script>
